<template>
  <span class="icon-container">
    <svg width="20" height="20" fill="white" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg">
      <path d="M896 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zm384 823q32-18 32-55t-32-55l-544-320q-31-19-64-1-32 19-32 56v640q0 37 32 56 16 8 32 8 17 0 32-9z"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: 'PlayIcon',
}
</script>

<style lang="scss" scoped>
.icon-container {
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// PlayIcon.vue?2cd4aa44